import Swiper from 'swiper/bundle'
import deepmerge from 'deepmerge'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import initPhotoSwipe from './initPhotoSwipe'
import swiperOverrides from './swiperOverrides'
import { createEvent, refreshScrollTrigger } from './_helpers'
import { scrollToElement } from './initScrollTo'
import cssAnimationObserver from './cssAnimationsObserver'
import { cssAnimationAttr } from './_constants'

gsap.registerPlugin(ScrollTrigger)

function toggleVideoPlayPause() {
  const video = this.closest('.swiper-slide').querySelector('video')

  if (video && video.paused) {
    video.play()
    this.classList.remove('paused')
  } else {
    video.pause()
    this.classList.add('paused')
  }
}

const videoPlayButton = document.querySelectorAll('[data-play-button]')
videoPlayButton.forEach(button => {
  button.addEventListener('click', toggleVideoPlayPause)
})

function checkSlideVideo(slider) {
  const btn = slider.el.parentElement.querySelector(
    '[data-swiper-fullscreen-button]'
  )

  const currentSlide = slider.slides[slider.activeIndex]
  const slideVideo = currentSlide.querySelector('video')

  if (slideVideo) {
    // slideVideo.play()
    btn?.classList.add('hide-opacity')
  } else {
    btn?.classList.remove('hide-opacity')

    const slidesVideos = slider.slides.filter(slide =>
      slide.querySelector('video')
    )
    slidesVideos.forEach(slide => {
      const video = slide.querySelector('video')
      const playBtn = slide.querySelector('[data-play-button]')
      playBtn?.classList.add('paused')
      if (video) {
        video.pause()
        video.currentTime = 0
      }
    })
  }
}

const swiperObserver = new IntersectionObserver(
  entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target
        const container =
          el.querySelector('.swiper-container:not(.swiper-container-thumbs)') ||
          el
        let config = {
          keyboard: true,
          lazy: true,
          navigation: true,
          preloadImages: false,
          watchSlidesVisibility: true,
          init: false,
        }
        let thumbsConfig = {
          ...config,
        }

        if ('override' in el.dataset) {
          config = deepmerge(config, swiperOverrides[el.dataset.override])
        }

        const prevEl = el.querySelector('.swiper-button-prev')
        const nextEl = el.querySelector('.swiper-button-next')
        if (nextEl && prevEl) {
          config.navigation = { nextEl, prevEl }
        }

        const thumbs = el.querySelector('[data-swiper-thumbs]')

        if (thumbs) {
          if ('override' in thumbs.dataset) {
            thumbsConfig = deepmerge(
              thumbsConfig,
              swiperOverrides[thumbs.dataset.override]
            )
          }

          config.thumbs = {
            swiper: new Swiper(thumbs, thumbsConfig),
          }
        }

        const swiper = new Swiper(container, config)

        swiper.on('init', () => {
          window.dispatchEvent(createEvent('swiperReady'))

          const swiperMap = document.querySelector(
            `#${swiper.el.dataset.swiperMap}`
          )

          // highlight slide when clicking on map
          if (swiperMap) {
            swiperMap
              .querySelectorAll('[data-highlight-carousel-items]')
              .forEach(link => {
                link.addEventListener('click', e => {
                  e.preventDefault()
                  scrollToElement(container)
                  const ids = link.dataset.highlightCarouselItems.split(',')
                  const slidesToHighlight = []
                  ids.forEach(id => {
                    const slide = container.querySelector(
                      `[data-map-id="${id}"]`
                    )
                    if (slide) {
                      slidesToHighlight.push(slide)
                    }
                  })
                  swiper.slides.forEach(slide => {
                    slide.classList.toggle(
                      'highlight',
                      slidesToHighlight.includes(slide)
                    )
                  })
                  if (slidesToHighlight[0]) {
                    const index = swiper.slides.indexOf(slidesToHighlight[0])
                    console.log({ index })
                    if (index !== -1) {
                      swiper.slideTo(index)
                    }
                  }
                })
              })
          }

          if (swiper.el.hasAttribute('data-swiper-fullscreen')) {
            const fsButton = swiper.el.parentElement.querySelector(
              '[data-swiper-fullscreen-button]'
            )

            initPhotoSwipe(swiper)

            fsButton.addEventListener('click', () => {
              swiper.slides[swiper.activeIndex]
                .querySelector('.swiper-image')
                .click()
            })
          }

          container
            .querySelectorAll(
              `.swiper-slide-duplicate${cssAnimationAttr}, .swiper-slide-duplicate ${cssAnimationAttr}`
            )
            .forEach(animationEl => {
              cssAnimationObserver.observe(animationEl)
            })
        })

        swiper.on('progress', () => {
          swiper.slidesGrid.forEach((slidePos, i) => {
            if (slidePos + swiper.translate < swiper.size + 200) {
              const slide = swiper.slides[i]
              if (!slide.querySelector('.swiper-lazy-loaded')) {
                swiper.lazy.loadInSlide(i)
              }
            }
          })
        })

        swiper.on('init', slider => checkSlideVideo(slider))
        swiper.on('slideChange', slider => checkSlideVideo(slider))

        swiper.on('lazyImageReady', refreshScrollTrigger)

        swiper.init()
        swiperObserver.unobserve(entry.target)

        if ('updateOnLazyLoad' in el.dataset) {
          el.querySelectorAll('img').forEach(img => {
            img.addEventListener('load', () => {
              swiper.update()
            })
          })
        }
      }
    })
  },
  {
    rootMargin: '500px 0px',
  }
)

export default swiperObserver
